<template>
    <div>
        <div class="row card-body p-3">
            <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3" style="margin: 0 auto;">
                <div v-if="showEsignature" class="col ">
                    <div class="card "  style="border:0px" :disabled="!validForm" @click="signDocument">
                        <v-btn varient="outlined" style="margin: 0 auto;margin-top: 0px; width: 85%;padding:20px;border:1px solid lightgrey">
                            <img src="/assets/images/icons/esignature.png" alt="UAEPASS"
                                width="4%"/>

                            <span v-if="lang=='en'" style="margin-left:5px;font-family: 'Times New Roman';font-size: 18px;">{{$t("res_ButtonText_ESignature")}}</span>
                            <span v-if="lang=='ar'" style="margin-right:5px;font-family: 'Times New Roman';font-size: 18px;">{{$t("res_ButtonText_ESignature")}}</span>

                        </v-btn>
                        
                    </div>
                </div>
                <div v-if="signUsingDocusignEnabled">
                    <div class="col select-Signature-Box">
                        <div class="card shadow-sm" @click="signDocumentWithDocusign">
                            <img src="/assets/images/icons/docusign.svg" style="margin: 0 auto;margin-top: 30px;" alt="UAEPASS"
                                width="60%" height="60%" />
                            <div class="card-body" style="text-align: center;">
                                <p class="card-text">{{$t("res_ButtonText_Docusign")}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3" style="margin: 0 auto;">
                <div v-if="signUsingUAEPassEnabled" class="col ">
                    <div class="card" style="border:0px" @click="choseUAEPassSign">
                        <img v-if="lang=='en'" src="/assets/images/UAEPASS_Sign_with_Btn_Outline_Default_Active_English.png" style="margin: 0 auto;margin-top: 0px;width:85%;height:54px" alt="UAEPASS"
                             />
                          <img v-if="lang=='ar'" src="/assets/images/UAEPASS_Sign_in_Btn_Outline_Default_Active_Arabic.png" style="margin: 0 auto;margin-top: 0px;width:316px;height:42px" alt="UAEPASS"
                             />   
                    </div>
                </div>
            </div>
        </div>
        <div style="padding-top: 15px;">
            <v-card-actions class="gap-2 sticky-actions">
                <v-spacer></v-spacer>
                <v-btn class="light-blue" style="min-width: 100px !important;" @click="cancelDialog">{{$t("res_ButtonText_Cancel")}}</v-btn>
            </v-card-actions>
        </div>
    </div>
</template>

<script>
import constants from '@/assets/js/constants'
import axios from 'axios'

export default {
    name: 'Sign',
    data() {
        return {
            pinValue: '',
            validForm: false,
            showEsignature: true,
            signUsingUAEPassEnabled: true,
            signUsingHashEnabled: false,
            signUsingDocusignEnabled: false,
            uaeImageUrl:"",
            lang:"",
            hashSignigBaseUrl : '',
            uaePassSignatureType: 'digital_signature'
        };
    },
    props: 
    {
        dialogModelShow: { type: Boolean, default: false },
        propertyBag: { type: Object },
        isSignAndSend: {type: Boolean, default: false},
        isUAEPassEnabledForTemplate: { type: Boolean, default: false },
        isEsealEnabledForTemplate: { type: Boolean, default: false },
        allowESignature: { type: Boolean, default: false },
        allowUAEPASSSignature: { type: Boolean, default: false },
    },
    methods:
    {
        resolvedDelegationId()
        {
            return this.propertyBag?.delegationId ?? 0
        },
        choseUAEPassSign()
        {
            if(uaePassSignatureType == 'digital_signature'){
                this.signDocumentWithUaePass();
            }
            else if(uaePassSignatureType == 'hash_sign'){
                this.hashSigning()
            }
        },
        hashSigning(){
            let baseUrl = constants.baseApiUrl;
           if (client_version_Id == 'MCY' && this.signUsingUAEPassEnabled) 
              {
                  baseUrl = constants.customUAEPassSignBaseApiUrl;
                  this.isUAEPassEnabledForTemplate = true;
               }
            window.showLoading()
            axios.get(constants.baseApiUrl + 'UAEPass/StartSignature')
                .then(res =>{
                    console.log('StartSignature = ',res)
                    if(res.data && res.data.url != ""){
                        console.log('res = ',res.data)
                        window.localStorage.setItem("documentId",this.propertyBag.documentId)
                        window.localStorage.setItem("transferId",this.propertyBag.transferId)
                        var windowObjectReference = window.open(res.data.url);
                        //HashSigningStatus
                        const checkStatus = () => 
                        {
                            this.checkUAEPassHashSignStatus(interval, windowObjectReference, baseUrl);
                        }

                        const interval = setInterval(() =>
                        {
                            checkStatus();
                        }, 2000);

                    }
                    else if(res.data && res.data._UAEPassSignatureResponse.Message != ""){
                        window.showAlert(res.data._UAEPassSignatureResponse.message, 'error')
                    }

                }).catch(err => window.showAlert(err, 'error'))
                
        },
        checkUAEPassHashSignStatus(interval, popup, baseUrl)
        {
                let token = sessionStorage.getItem('jwt_token');
                let documentId = this.propertyBag.documentId;

                axios.get(baseUrl + 'UAEPass/HashSigningStatus?DocumentId=' + this.propertyBag.documentId + '&transferId=' + this.propertyBag.transferId)
                    .then(res => 
                    {
                        if (res.data == "" || res.data == undefined || res.data == null || res.data == "Pending")
                            return;
                        clearInterval(interval);
                        popup.close();
                        
                        this.$emit('refreshAfterClosingSignMethodSelect');
                    })
                    .catch(err => window.showAlert(err, 'error'))
                    .finally(()=> window.hideLoading())
        },
        getPermissionToSign() 
        {
            window.showLoading()
            axios.get(constants.baseApiUrl + 'Document/CheckHasValidSignature?delegationId=' + this.resolvedDelegationId())
                .then(res => 
                {
                    if (res.data == 'SignaturePinNotSet')
                        window.showAlert('You have not set a signature pin. Please set a signature pin in your profile', 'warning')

                    else if (res.data == 'NoDefaultSignatureFound')
                        window.showAlert('You don\'t have a default signature. Please add a signature and set it to default', 'warning')

                    else
                        this.validForm = true
                })
                .catch(err => window.showAlert(err, 'error'))
                .finally(() => window.hideLoading())

            if (sessionStorage.getItem('sign_using_UAEPass') != null)
                this.signUsingUAEPassEnabled = (sessionStorage.getItem('sign_using_UAEPass') === "true")
            if (sessionStorage.getItem('sign_using_Hash') != null)
                this.signUsingHashEnabled = (sessionStorage.getItem('sign_using_Hash') === "true")

            if (sessionStorage.getItem('sign_using_Docusign') != null)
                this.signUsingDocusignEnabled = (sessionStorage.getItem('sign_using_Docusign') === "true")
        },
        signDocument() 
        {
            this.$emit('closeSignMethodSelectAndOpenSignWithPin')
        },
        signDocumentWithUaePass() 
        {
           let baseUrl = constants.baseApiUrl;
           if (this.signUsingUAEPassEnabled) 
              {
                  this.isUAEPassEnabledForTemplate = true;
               }

            if(this.isUAEPassEnabledForTemplate){
                window.showLoading();
              
                axios.get(baseUrl + 'Document/CheckHasValidSignature?delegationId=' + this.resolvedDelegationId())
                    .then(res => 
                    {
                        if (res.data == 'SignaturePinNotSet')
                            window.showAlert('You have not set a signature pin. Please set a signature pin in your profile', 'warning')

                        else if (res.data == 'NoDefaultSignatureFound')
                            window.showAlert('You don\'t have a default signature. Please add a signature and set it to default', 'warning')

                        else
                            {
                                axios.post(baseUrl + 'Document/SignUAEPassDocuments?documentId=' + this.propertyBag.documentId + '&transferId=' + this.propertyBag.transferId + '&delegationId=' + this.resolvedDelegationId())
                    .then(res => 
                    {
                        console.log('uae res  = ',res)
                        let token = sessionStorage.getItem('jwt_token');
                        let documentId = this.propertyBag.documentId;
                        var w = 720;
                        var h = 530;
                        var title = '_blank'
                        var left = (screen.width / 2) - (w / 2);
                        var top = (screen.height / 2) - (h / 2);
                        console.log("IsEsealEnabledForTemplate = ",this.isEsealEnabledForTemplate )
                        // window.close();
                        var windowObjectReference = window.open(baseUrl + 'UAEPass?id=' + documentId +'&storageAttachmentId='+0+ '&x='+res.data.item1.x+'&y='+res.data.item1.y+ '&stampX='+res.data.item2.x+'&stampY='+res.data.item2.y+'&ltvEnabled='+constants.ltvEnabled+'&esealEnabled='+this.isEsealEnabledForTemplate+"&lang="+this.lang+'&token=' + token, title);

                        const checkStatus = () => 
                        {
                            this.checkUAEPassSignStatus(interval, windowObjectReference, baseUrl);
                        }

                        const interval = setInterval(() =>
                        {
                            checkStatus();
                        }, 2000);
                    })
                    .catch(error => console.log(error))
                            }
                    })
                    .catch(err => window.showAlert(err, 'error'))
            }
            else{
                window.showAlert(this.$t('res_Msgs_UAEPASSNotEnabledForTemplage'), 'warning')
            }
            
        },

        signDocumentWithDocusign() 
        {
            window.showLoading();
            let baseUrl = constants.baseApiUrl;
            axios.post(baseUrl + 'Document/PrepareDocumentForDocuSign?documentId=' + this.propertyBag.documentId + '&transferId=' + this.propertyBag.transferId + '&delegationId=' + this.resolvedDelegationId())
                .then(res => 
                {
                    let token = sessionStorage.getItem('jwt_token');
                    var windowObjectReference = window.open(res.data.item2,"Sign With Docusign",'_blank');
                    var envelopeId=res.data.item1;
                    window.hideLoading();
                    console.log('data', res)
                })
                .catch(error => console.log(error))
        },

        checkUAEPassSignStatus(interval, popup, baseUrl)
        {
            if (popup.closed == true) 
            {
                window.hideLoading()
            }
            else 
            {
                let token = sessionStorage.getItem('jwt_token');
                let documentId = this.propertyBag.documentId;

                axios.get(baseUrl + 'UAEPass/SigningStatus?DocumentId=' + documentId + '&token=' + token)
                    .then(res => 
                    {
                        if (res.data == "" || res.data == undefined || res.data == null)
                            return;
          
                        if (res.data == "finished") 
                        {
                            // window.showAlert('Successfully Signed', 'success')
                            axios.post(baseUrl + 'Document/MarkDocumentSigned?documentId=' + this.propertyBag.documentId + '&transferId=' + this.propertyBag.transferId + '&delegationId=' + this.resolvedDelegationId())
                                .then(res => 
                                {
                                  
                                    // setTimeout(async ()=> {
                                    //     if(constants.ltvEnabled){
                                    //         await this.$emit('refreshAfterClosingSignMethodSelect')
                                    //         this.lTVDocument()
                                    //     }
                                    //     else if(constants.esealEnabled){
                                    //         await this.$emit('refreshAfterClosingSignMethodSelect')
                                    //         this.eSealDocument()
                                    //     }
                                    //     else{
                                            window.hideLoading();
                                            window.showAlert(this.$t('res_Msgs_SignedSuccess'), 'success')
                                            
                                            
                                            console.log('uae cleared = ',res)
                                            console.log("issigneandsend = ",this.isSignAndSend)
                                            if(this.isSignAndSend){
                                                window.showLoading()
                                                this.$emit('uaeDocumentSigned')
                                            }
                                            else{
                                                this.$emit('refreshAfterClosingSignMethodSelect')
                                            }
                                    //     }
                                    
                                    // }, 2000);
                                    
                                })
                        }
                        else 
                        {
                            window.showAlert('Something went wrong', 'warning')
                            this.$emit('refreshAfterClosingSignMethodSelect')
                            window.hideLoading();
                        }
                        clearInterval(interval);
                        popup.close();
                        
                        this.$emit('refreshAfterClosingSignMethodSelect');
                    })
                    .catch(err => window.showAlert(err, 'error'))
            }
        },
        
        eSealDocument(){
            let baseUrl = constants.baseApiUrl;
            let documentId = this.propertyBag.documentId;
            axios.get(baseUrl + 'UAEPass/ESealDocument?documentId=' + documentId )
                    .then(res => 
                    {
                        console.log("eseal = ",res)
                        window.hideLoading();
                        window.showAlert(this.$t('res_Msgs_SignedSuccess'), 'success')
                        this.$emit('refreshAfterClosingSignMethodSelect')
                    })  
        },
        
        lTVDocument(){
            let baseUrl = constants.baseApiUrl;
            let documentId = this.propertyBag.documentId;
            axios.get(baseUrl + 'UAEPass/LTVDocument?documentId=' + documentId )
            .then(async res => 
            {
                console.log("eseal = ",res)
                if(constants.esealEnabled){
                    await this.$emit('refreshAfterClosingSignMethodSelect')
                    setTimeout(async ()=> {
                    this.eSealDocument(),2000})
                }
                else{
                    window.hideLoading();
                    window.showAlert(this.$t('res_Msgs_SignedSuccess'), 'success')
                    this.$emit('refreshAfterClosingSignMethodSelect')
                }
                
            })  
        },
        
        cancelDialog() 
        {
            this.$emit('closeSelectSignMethodFormDialog');
        },
        
        resetForm() 
        {
            this.pinValue = ''
            this.validForm = false
        },

        checkDocusignEnvolvement()
        {
            let baseUrl = constants.baseApiUrl;
            axios.post(baseUrl + 'Document/CheckIfSignedFromExternalSystem?documentId=' + this.propertyBag.documentId )
                .then(res => 
                {
                    if (res.data)
                        this.showEsignature = false;
                })
                .catch(error => console.log(error))
        }
    },
    watch:
    {
        dialogModelShow(newVal, oldVal) 
        {
            if (newVal != oldVal) 
            {
                if (newVal == true)
                    this.getPermissionToSign()
                else
                    this.resetForm()
            }
        }
    },
    mounted: function () 
    {
        this.uaePassSignatureType = window.uaePassSignatureType
        this.getPermissionToSign()
        this.checkDocusignEnvolvement()
        //AR_UAEPASS_Continue with_Btn_Default_Black_Focus.svg
        ///UAEPASS_Continue with_Btn_Default_Black_Active.svg
        ///assets/images/UAEPASS_Continue with_Btn_Default_Black_Active.svg
        this.lang = 'en'
        if (localStorage.getItem('lang') != null){

            this.lang = localStorage.getItem('lang')
        }
        if(this.lang=="en"){
            this.uaeImageUrl = "/assets/images/UAEPASS_Sign_with_Btn_Outline_Default_Active_English.png";
        }
        else{
            this.uaeImageUrl = "/assets/images/UAEPASS_Sign_in_Btn_Outline_Default_Active_Arabic.png";
        }
        this.hashSignigBaseUrl = window.hashSignigBaseUrl;

        if(this.allowUAEPASSSignature && !this.allowESignature)
        {
            this.choseUAEPassSign()
        }
    }
}
</script>